import React from 'react';
import { ShieldCheck, Anchor, Users } from 'lucide-react';
export function About() {
  return <section id="about" className="py-20 bg-white" data-id="element-1">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-2">
        <div className="lg:grid lg:grid-cols-2 lg:gap-16 items-center" data-id="element-3">
          {/* Text Content */}
          <div className="mb-12 lg:mb-0" data-id="element-4">
            <h2 className="text-3xl md:text-4xl font-bold text-slate-900 mb-6" data-id="element-5">
              Kaduna's Trusted Source for{' '}
              <span className="text-teal-600" data-id="element-6">Premium Seafood</span>
            </h2>

            <div className="prose prose-lg text-slate-600 mb-8" data-id="element-7">
              <p className="mb-4" data-id="element-8">
                Located on Aliyu Makama Road in Barnawa, Gauchos Frozen Food has
                established itself as a cornerstone of quality in the local food
                industry. We understand that whether you're a top-tier
                restaurant or a home cook, the quality of your ingredients
                defines your meal.
              </p>
              <p data-id="element-9">
                We specialize in sourcing and distributing the finest frozen
                seafood products, ensuring that every item in our inventory
                meets rigorous standards for freshness and taste. Our commitment
                to reliability makes us the preferred partner for food
                businesses across Kaduna.
              </p>
            </div>

            <div className="grid grid-cols-1 sm:grid-cols-3 gap-6 mt-8" data-id="element-10">
              <div className="flex flex-col items-start" data-id="element-11">
                <div className="p-3 bg-blue-50 rounded-lg mb-3" data-id="element-12">
                  <ShieldCheck className="h-6 w-6 text-blue-700" data-id="element-13" />
                </div>
                <h3 className="font-semibold text-slate-900" data-id="element-14">
                  Quality Assured
                </h3>
                <p className="text-sm text-slate-500 mt-1" data-id="element-15">
                  Rigorous checks on all stock
                </p>
              </div>

              <div className="flex flex-col items-start" data-id="element-16">
                <div className="p-3 bg-teal-50 rounded-lg mb-3" data-id="element-17">
                  <Anchor className="h-6 w-6 text-teal-600" data-id="element-18" />
                </div>
                <h3 className="font-semibold text-slate-900" data-id="element-19">
                  Direct Sourcing
                </h3>
                <p className="text-sm text-slate-500 mt-1" data-id="element-20">
                  From the best suppliers
                </p>
              </div>

              <div className="flex flex-col items-start" data-id="element-21">
                <div className="p-3 bg-slate-100 rounded-lg mb-3" data-id="element-22">
                  <Users className="h-6 w-6 text-slate-700" data-id="element-23" />
                </div>
                <h3 className="font-semibold text-slate-900" data-id="element-24">Local Focus</h3>
                <p className="text-sm text-slate-500 mt-1" data-id="element-25">
                  Serving our community
                </p>
              </div>
            </div>
          </div>

          {/* Visual/Image Placeholder */}
          <div className="relative h-96 lg:h-full min-h-[400px] rounded-2xl overflow-hidden bg-slate-100 shadow-xl" data-id="element-26">
            <div className="absolute inset-0 bg-slate-200 flex items-center justify-center" data-id="element-27">
              {/* In a real project, this would be a photo of the storefront or products */}
              <div className="text-center p-8" data-id="element-28">
                <div className="mx-auto w-20 h-20 bg-white rounded-full flex items-center justify-center shadow-sm mb-4" data-id="element-29">
                  <Anchor className="h-10 w-10 text-blue-900" data-id="element-30" />
                </div>
                <p className="text-slate-400 font-medium" data-id="element-31">
                  Gauchos Frozen Food
                </p>
                <p className="text-slate-400 text-sm" data-id="element-32">
                  Aliyu Makama Road, Barnawa
                </p>
              </div>
            </div>
            {/* Decorative pattern overlay */}
            <div className="absolute inset-0 bg-gradient-to-tr from-blue-900/10 to-transparent pointer-events-none" data-id="element-33" />
          </div>
        </div>
      </div>
    </section>;
}